import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
const TaskResource = z.object({
    type: z.literal("Task"),
    id: z.string(),
});
const TaskCommentResource = z.object({
    type: z.literal("TaskComment"),
    id: z.string(),
});
const AttachmentResource = z.object({
    type: z.literal("Attachment"),
    id: z.string(),
});
const deleteResources = z.array(z.union([TaskResource, TaskCommentResource, AttachmentResource]));
const DeleteActionSchema = z.object({
    request: z.object({
        action: z.literal("delete"),
        resources: deleteResources,
    }),
    results: deleteResources,
});
const editResources = z.array(z.union([TaskResource, TaskCommentResource]));
const EditActionSchema = z.object({
    request: z.object({
        action: z.literal("edit"),
        resources: editResources,
    }),
    results: editResources,
});
const EditMetadataActionSchema = z.object({
    request: z.object({
        action: z.literal("editMetadata"),
        resources: z.array(TaskResource),
    }),
    results: z.array(TaskResource),
});
const Response = z.union([
    DeleteActionSchema,
    EditActionSchema,
    EditMetadataActionSchema,
]);
export const url = () => {
    return environment() === "PROD"
        ? `https://middleware.prod.farther.com/authz/v1/check/resources`
        : `https://middleware.uat.farther.com/authz/v1/check/resources`;
};
export default async function getAuthzCheckBatch(check, config) {
    const res = await axios.post(url(), check, {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            ...("advisorId" in config && { Advisor: config.advisorId }),
            ...("clientId" in config && { Client: config.clientId }),
        },
    });
    const decoded = Response.safeParse(res.data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = "Could not decode authz batch check response";
        errorLog("getAuthzCheckBatch", `${decoded.error.message} ${JSON.stringify(decoded.error.issues)}`);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getAuthzCheckBatch.js.map